import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { ENDPOINTS, ORG_DETAILS } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  // Initialize the cartProducts array
  private cartProductsSubject = new BehaviorSubject<any[]>([]);

  // Observable to expose the cartProducts array to other components
  cartProducts$ = this.cartProductsSubject.asObservable();
  constructor(private appService: AppService) { }

  // Method to update the cart products array
  updateCartProducts(products: any[]) {
    this.cartProductsSubject.next(products);
  }

  // Method to add a product to the cart
  addProductToCart(product: any) {
    const currentCart = this.cartProductsSubject.value;
    this.cartProductsSubject.next([...currentCart, product]);
  }



}
